import { render, staticRenderFns } from "./ConclusionDetail.vue?vue&type=template&id=2f1939d4&"
import script from "./ConclusionDetail.vue?vue&type=script&lang=js&"
export * from "./ConclusionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports